import { useLayoutBase } from '../layout-base';
import NewsLayout from './NewsLayout.vue';

// static module imports
import { Hea01Header } from '@otp-modules/hea01-header';
import { Foo01Footer } from '@otp-modules/foo01-footer';
import { Her01Hero } from '@otp-modules/her01-hero';

(async () => {
	const { getLayout } = useLayoutBase('news');
	const layout = await getLayout();
	layout.component('NewsLayout', NewsLayout);

	layout.component('Hea01Header', Hea01Header);
	layout.component('Foo01Footer', Foo01Footer);
	layout.component('Her01Hero', Her01Hero);

	layout.mount('#app');
})();
